module.exports = {
    // 公共語言檔
    Common: {
        "person": "人",
        "each": "個",
        "page": "每頁 ",
        "item": " 條",
        "currentPage": "當前頁",
        "woman": "女",
        "man": "男",
        "noSex": "待定",
        btn_complete: '完成',
        btn_confirm: '確定',
        btn_cancel: '取消',
        btn_export: '導出',
        exportTips: '報表內容為空，不可導出',
        btn_submit: '提交',
        btn_edit: '編輯',
        tips: '提示',
        options: '不限',
        operatesLabel: '操作',
        closeTips: '確認關閉？',
        delTips: '確定要刪除本條信息嗎？',
        errorMessage: '請填寫所有的必填項！',
        editTableTitle: '編輯列',
        editTableTitles: ['已顯示列', '未顯示的列'],
        workMenu: '功能菜單',
        empty_tips: '暫時沒有內容哦',
        personalInfo_tips: '為未同意個人資料保護法',
        "age": "歲",
        "times": "次",
        "keyWord": "關鍵詞：",
        "startTime": "開始時間",
        "endTime": "結束時間",
        "to": "至",
        create_time: '創建時間',
        loadTip1: '加載中……',
        loadTip2: '加載超時',
        loadTip3: '請重新登錄！',
        loadTip4: '加載失敗'
    },
    // 組件中文字---start
    Header: {
        title: '校務招生CRM',
        menu1: '校務中心',
        menu2: '招生CRM',
        menu3: '家園互動',
        menu4: '控制中心',
        nav_title1: '招生',
        nav_title2: 'CRM',
        exchange: '切換',
        dropdown_item1: '個人信息',
        dropdown_item2: '聯系人',
        dropdown_item3: '切換職務',
        dropdown_item4: '退出登錄',
        s_title1: '請選擇您要進入的學校',
        placeholder1: '請選擇區域',
        placeholder2: '省',
        placeholder3: '市',
        placeholder4: '請輸入校園編號,校園名稱',
        message_labe1: '最新消息',
        message_labe2: '歷史信息',
        message_labe3: '設置提醒',
        contact_label1: '招生聯系人',
        myInfo_label1: '個人資料',
        myInfo_label2: '基本信息',
        label_text1: '姓名：',
        info_placeholder1: '請輸入姓名',
        label_text2: '手機號：',
        info_placeholder2: '請輸入手機號',
        label_text3: '頭像：',
        post_label1: '選擇分校',
        post_label2: '選擇職務',
        slider_nav_name1: '切換集團',
        slider_nav_name2: '教學影片',
        slider_nav_name3: '常見問題',
        slider_nav_name4: '查看文檔',
        slider_nav_name5: "在線諮詢",
        video_title: '觀看教學視頻',
        word_title1: '查看文檔',
        word_title2: '文檔列表',
        word_title3: '文檔詳情',
        mmd: '毛名單',
        searchTxt: '名單搜尋'
    },
    Calendar: {
        title: '日程',
        label_text1: '年',
        label_text2: '月',
        placeholder1: '選擇月',
        btn_text1: '創建',
        wk1: '日',
        wk2: '一',
        wk3: '二',
        wk4: '三',
        wk5: '四',
        wk6: '五',
        wk7: '六',
        btn_text2: '展開全月',
        btn_text3: '收起全月',
        label_text3: '新建日程',
        label_text4: '時間：',
        placeholder2: '設置時間',
        placeholder3: '請填寫內容',
        rules_text1: '請選擇設置時間',
        rules_text2: '請填寫內容',
    },
    Aims: {
        title: '新建招生目標',
        title2: '編輯目標',
        s_title1: '基礎資料',
        s_title2: '請設置參與目標考核的員工',
        label_text1: '目標名稱：',
        placeholder1: '請輸入招生目標名稱',
        label_text2: '開始時間：',
        placeholder2: '目標開始時間',
        label_text3: '結束時間：',
        placeholder3: '目標結束時間',
        label_text4: '跟蹤人次：',
        placeholder4_1: '請輸入最少人次',
        placeholder4_2: '請輸入達標人次',
        label_text5: '櫃詢/試聽人次：',
        placeholder5_1: '櫃詢/試聽最少人數',
        placeholder5_2: '櫃詢/試聽達標人數',
        label_text6: '學員轉正人次：',
        placeholder6_1: '學員轉正最少人次',
        placeholder6_2: '學員轉正達標人次',
        label_text7: '自主招生跟蹤最大人次：',
        placeholder7: '請輸入自主招生跟蹤最大人次',
        label_text8: '選擇職工：',
        placeholder8: '已選擇',
        placeholder9: '人',
        tooltips_cont: '自主跟進上限人數，指的是招生負責人在招生有效名單自主跟進的最大人數，超過此設置的人數，不能自主跟進，需讓主管或者校長分配有效名單',
        rule_tips1: '不能為空',
        rule_tips1_2: '請輸入正確的格(非零的正整數)',
        rule_tips2: '請輸入招生目標名稱',
        rule_tips3: '長度在 2 到 30 個字符',
        rule_tips4: '請選擇目標開始時間',
        rule_tips5: '請選擇目標結束時間',
        rule_tips6: '請輸入自主招生跟蹤最大人次',
        rule_tips7: '最少人次不能大於達標人次',
        rule_tips8: '達標人次不能小於最少人次',
        rule_tips9: '最少人數不能大於達標人數',
        rule_tips10: '達標人數不能小於最少人數',
        rule_tips11: '最少人次不能大於達標人次',
        rule_tips12: '達標人次不能小於最少人次',
    },
    User: {
        img_text1: '上傳頭像',
        s_title1: '基礎信息',
        s_title2: '重復記錄',
        s_title3: '家庭聯繫資訊',
        s_title4: '招生資訊',
        s_title5: '意向課程信息',
        s_title6: '備註',
        s_title7: '跟蹤記錄',
        s_title8: '櫃詢記錄',
        s_title9: '試聽記錄',
        s_title10: '跟進基礎信息',
        s_title11: '最近兩次跟進記錄',
        s_title12: '基礎資訊',
        man: '男',
        woman: '女',
        label_text1: '中文名：',
        placeholder1: '請輸入中文名',
        label_text2: '英文名：',
        placeholder2: '請輸入英文名',
        label_text3: '性別：',
        placeholder3: '請選擇性別',
        label_text4: '手機號：',
        placeholder4: '請輸入手機號',
        label_text5: '出生日期：',
        placeholder5: '選擇日期',
        label_text6: '身份證號：',
        placeholder6: '請輸入身份證號',
        label_text7: '家庭資訊:',
        placeholder7_1: '親屬關係',
        placeholder7_2: '親屬姓名',
        placeholder7_3: '請輸入手機號',
        label_text8: '招生來源類型：',
        placeholder8: '請選擇招生來源類型',
        options1: ['外部招生', '內招生', '專案招生'],
        label_text9: '招生渠道類型：',
        placeholder9: '請選擇招生渠道類型',
        label_text10: '招生渠道明細：',
        placeholder10: '請選擇招生渠道明細',
        label_text11: '客戶意向星级：',
        label_text12: '介紹人：',
        placeholder12: '請輸入介紹人',
        label_text13: '主負責人：',
        placeholder13: '請選擇主負責人',
        label_text14: '協助負責人：',
        placeholder14: '請選擇協助負責人',
        label_text15: '意向課程:',
        placeholder15: '請選擇意向課程',
        label_text16: '特殊備註：',
        placeholder16: '請輸入備註信息',
        label_text17: '主要聯系人：',
        label_text18_1: '家長姓名：',
        label_text18_2: '家長身份：',
        label_text18_3: '家長手機號：',
        label_text18_4: '附近就讀學校：',
        label_text18_4_ph: '請選擇附近就讀學校',
        label_text18_5: '省市區：',
        label_text18_5_ph1: '請選擇省',
        label_text18_5_ph2: '請選擇市',
        label_text18_5_ph3: '請選擇區',
        label_text19: '客戶狀態：',
        btn_text1: '設置為主要聯繫人',
        btn_text2: '繼續添加',
        tips1: '當前有重復記錄',
        record_text1: '歲',
        record_text2: '負責人：',
        record_text3: '客戶狀態：',
        rule_tips1: '手機號不能為空',
        rule_tips2: '請輸入正確的手機號',
        rule_tips3: '請輸入正確的身份證號',
        rule_tips4_1: '請輸入中文名',
        rule_tips4_2: '長度在 2 到 10 個字符',
        rule_tips5: '請輸入英文名',
        rule_tips6: '請選擇性別',
        rule_tips7: '請選擇出生日期',
        rule_tips8: '請輸入主負責人',
        rule_tips9: '請選擇招生渠道類型',
        rule_tips10: '請選擇招生渠道明細',
        message_tips: '上傳頭像圖片只能是 JPG/PNG/GIF 格式!',
        see_btn_more: '更多',
        see_btn_bind: '綁定學員',
        tab_pane1: '基本資訊',
        tab_pane2: '跟蹤記錄',
        tab_pane3: '櫃詢試聽記錄',
        tab_pane4: '跟進',
        tab_pane5: '綁定學員',
        follow_label1: '溝通類型：',
        follow_placeholder1: '請選擇溝通類別',
        follow_label2: '溝通對象：',
        follow_placeholder2: '請選擇溝通對象',
        follow_label3: '溝通效果：',
        follow_options1: ['有效溝通', '無效溝通'],
        follow_label4: '意向級別：',
        follow_label5: '本次跟進類型：',
        follow_label166: "跟進班組：",
        follow_options2: ['櫃詢', '試聽', '普通回訪', '已確認無意向', '無效名單'],
        follow_label6: '試聽類型：',
        follow_placeholder6: '請選擇試聽類型',
        follow_options3: ['公開課試聽', '插班試聽'],
        follow_label7: '接待人：',
        follow_placeholder7: '請選擇接待人',
        follow_label8: '櫃詢類型：',
        follow_placeholder8: '請選擇櫃詢類型',
        follow_options4: ['普通櫃詢', '能力測試'],
        follow_label9: '櫃詢到訪日：',
        follow_placeholder9: '請選擇到訪日期',
        follow_label10: '試聽日期：',
        follow_placeholder10: '請選擇試聽日期',
        follow_label11: '試聽班級：',
        follow_placeholder11_1: '請選擇試聽班級',
        follow_placeholder11_2: '請輸入試聽班級',
        follow_label12: '回訪日期：',
        follow_placeholder12: '請選擇回訪日期',
        follow_label13: '無意向類型：',
        follow_placeholder13: '請選擇無意向類型',
        follow_options5: ['已報異業', '強烈抵觸', '其他'],
        follow_label14: '溝通內容：',
        follow_placeholder14_1: '請選擇模板',
        follow_placeholder14_2: '請輸入溝通內容',
        follow_label15: '下次跟進類型：',
        follow_placeholder15: '請選擇下次跟進類型',
        follow_options6: ['普通跟進', '提醒跟進'],
        follow_label16: '下次跟進日期：',
        follow_placeholder16: '請選擇下次跟進日期',
        follow_rule1: '請輸入接待人',
        follow_rule2: '請選擇試聽班級',
        follow_rule3: '請選擇到訪日期',
        follow_rule4: '請選擇試聽日期',
        follow_rule5: '請輸入溝通內容',
        baseInfo: '基礎信息',
        BindShip: '綁定關系：',
        noBindRecord: '暫無綁定學員記錄',
        followRecord: '跟蹤記錄',
        tryDate: '試聽日期：',
        tryClass: '試聽班級：',
        guiDate: '櫃詢日期：',
        nextFollowDate: '下次跟進日期：',
        typecname: '跟進班組：',
        followSchool: '跟蹤學校：',
        communiteContent: '溝通內容：',
        noFollowRecord: '暫無跟蹤記錄',
        noFollowRecord2: '暫無跟進記錄',
        CounterRecord: '櫃詢記錄',
        tryRecord: '試聽記錄',
        btn_text3: '跟進',
        btn_text4: '閱',
        btn_text5: '已閱',
        btn_text6: '回覆',
        replay_placeholder: '請輸入回覆內容',
        label_text20: '於',
        label_card: '身份證號:',

        label_text21: '是否有推薦人：',
        recommend: ['是', '否'],
        label_text22: '推薦人：',
        label_text23: '就讀校區：',
        placeholder18: "推薦人姓名、聯系電話、學員編號搜索",
        rule_tips11: '請選擇是否推薦名單',
        rule_tips12: '請選擇推薦人',
        tips: '未設置',
        errorMessage1: '請輸入推薦人姓名、聯系電話、學員編號搜索',
        ab: "添加標籤",
        aa: "常用標籤",
        ac: "外撥紀錄",
        ae: "標籤：",
        af: "客戶當前意向星级",
        ag: "跟進班種：",
        ah: "請選擇跟進班種",
        ai: "溝通模板：",
        aj: "溝通內容：",
        ak: "請選擇常用溝通模板",
    },
    Class: {
        title1: '公開課試聽',
        title2: '插班試聽',
        S_title: '選擇試聽班級',
        label_text1: '課程名稱：',
        placeholder1: '請輸入課程名稱',
        label_text2: '選擇教師：',
        placeholder2: '請選擇教師',
        label_text3: '上課日期：',
        placeholder3: '選擇日期',
        placeholder4: '選擇課程名稱',
        label_text4: '當前已選擇：',
        label_text5: '上課日期：',
        label_text6: '上課時間：',
    },
    Report1: {
        errorMessage1: '報表內容為空，不可導出',
        placeholder1: '開始日期',
        placeholder2: '至',
        placeholder3: '結束日期',
        placeholder4: '選擇月份',
        label_text1: '招生渠道類型：',
        placeholder5: '招生渠道類型',
        label_text2: '招生渠道明細：',
        placeholder6: '招生渠道明細',
        label_text3: '名單狀態：',
        placeholder7: '名單狀態',
        options: ['待跟蹤', '持續跟蹤', '已櫃詢', '已試聽', '已轉正', '無意向', '無效名單'],
    },
    Table: {
        label_text1: '空閑',
        label_text2: '有課',
        label_text3: '外地',
        label_text4: '本地',
        noreadTips: '未讀'
    },
    active: {
        publishActive: '發布活動',
        confirmPublish: '確認發布',
        confirmEdit: '確定修改',
        baseInfo: '基本信息',
        aboutUs: '關於我們',
        CustomDetails: '自定義詳情',
        activeName: '活動名稱:',
        activeNamePlaceHold: '請輸入活動名稱',
        nameOnly: '活動名稱唯一',
        activeType: '活動類型:',
        normal: '普通活動',
        EnrollmentStu: '招生券活動',
        activeTopic: '活動主題:',
        activeTopicPlaceHold: '請輸入活動主題',
        activeWHTopic: '主圖寬高:',
        activeWPlaceHold: '請輸入主圖寬',
        activeHPlaceHold: '請輸入主圖高',
        activeTime: '活動時間:',
        activeStartTime: '活動開始時間',
        activeEndTime: '活動結束時間',
        activeEnd: '活動結束不可再參加活動',
        channelType: '招生渠道類型:',
        channelTypePlaceHold: '請選擇招生渠道類型',
        channelDetail: '招生渠道明細:',
        channelDetailPlaceHold: '請選擇招生渠道明細',
        activeTemlate: '活動模板：',
        systemTemlate: '系統模板',
        customTemlate: '自定義模板',
        selectTemlate: '請選擇活動模板',
        previewTemlate: '預覽模板',
        urlPlaceHold: '請輸入自定義模板的URL鏈接',
        phone: '聯系電話：',
        phonePlaceHold: '請輸入聯系電話',
        address: '聯系地址：',
        addressPlaceHold: '請輸入聯系地址',
        fileImg: '上傳主圖：',
        fileImgPlaceHold: '請上傳主圖',
        activeDetail: '活動詳情：',
        viewPriew: '查看預覽圖',
        activeRule: '活動規則：',
        activeRulePlaceHold: '請輸入活動規則',
        shareDescrible: '分享描述：',
        shareDescriblePlaceHold: '請輸入分享描述',
        shareImg: '分享圖片：',
        shareImgPlaceHold: '請上傳分享圖片',
        rule_tips1: '手機號不能為空',
        rule_tips2: '請輸入正確的手機號',
        rule_tips3: '請輸入招生活動名稱',
        rule_tips4: '長度在 2 到 50 個字符',
        rule_tips51: '請選擇活動類型',
        rule_tips6: '請選擇活動開始時間',
        rule_tips7: '請輸入活動主題',
        rule_tips8: '請選擇活動結束時間',
        rule_tips9: '請選擇招生渠道類型',
        rule_tips10: '請選擇招生渠道明細',
        rule_tips11: '請輸入聯系電話',
        rule_tips12: '開始時間和結束時間不能相同',
    },
    // 海報活動組件
    posterActive: {
        publishActive: '發布活動',
        confirmPublish: '確認發布',
        confirmEdit: '確定修改',
        activeEnd: '活動結束不可再參加活動',
        nameOnly: '活動名稱唯一',
        item_text1: '海報活動名稱：',
        form_phoder1: '請輸入海報活動名稱',
        item_text2: '海報活動主題：',
        form_phoder2: '請輸入海報活動主題',
        item_text3: '活動時間：',
        form_phoder3_1: '開始時間',
        form_phoder3_2: '至',
        form_phoder3_3: '結束時間',
        item_text4: '招生渠道類型：',
        form_phoder4: '選擇招生渠道類型',
        item_text5: '招生渠道明細：',
        form_phoder5: '選擇招生渠道明細',
        item_text6: '上傳海報封面圖：',
        form_phoder6: '請上傳海報封面圖',
        item_text7: '選擇海報模版：',
        form_phoder7: '請選擇海報模版',
        item_text8: '分享描述：',
        form_phoder8: '請輸入分享描述',
        item_text9: '分享圖片：',
        form_phoder9: '請上傳分享圖片',
        item_text10: '上傳海報主圖：',
        form_phoder10: '請上傳海報主圖',
        item_text11: '活動介紹：',
        form_phoder11: '請輸入活動介紹',
        rule_tips1: '手機號不能為空',
        rule_tips2: '請輸入正確的手機號',
        rule_tips3: '請輸入海報活動名稱',
        rule_tips4: '長度在 2 到 50 個字符',
        rule_tips51: '請選擇活動類型',
        rule_tips6: '請選擇活動開始時間',
        rule_tips7: '請輸入海報活動主題',
        rule_tips8: '請選擇活動結束時間',
        rule_tips9: '請選擇招生渠道類型',
        rule_tips10: '請選擇招生渠道明細',
        rule_tips11: '請輸入聯系電話',
    },
    // 組件中文字---end
    home: {
        "aa": "首頁",
        "ab": "統計信息",
        "ac": "招生統計",
        "ad": "至",
        "a1": "開始日期",
        "ae": "結束日期",
        "af": "選擇校園職工篩選",
        "ag": "招生轉化統計",
        "ah": "選擇校園職工篩選",
        "ai": "招生有效名單轉化",
        "aj": "選擇校園職工篩選",
        "ak": "有效名單轉化為意向客戶數量 / 轉化率",
        "al": "到訪率: 意向客戶轉化為試聽客戶數量(轉化率)",
        "am": "面轉率: 意向客戶轉化為正式客戶數量(轉化率)",
        "an": "無意向率: 有效名單轉化無意向客戶數量(轉化率)",
        "ao": "本周招生跟蹤提醒",
        "ap": "更多",
        "aq": "已跟進",
        "ar": "未跟進",
        "aw": "上次跟進時間：",
        "as": "本周暫無招生跟蹤提醒",
        "at": "招生跟蹤提醒記錄",
        "au": "關鍵詞：",
        "av": "請輸入姓名查詢",
        "aww": "提醒時間：",
        "ax": "我的跟蹤記錄",
        "ay": "7日內",
        "az": "30日內",
        "ba": "高級篩選",
        "bb": ['7日內', '30日內', '高級篩選'],
        "bc": "新增客戶名單數",
        "bd": "新增意向客戶",
        "be": "新增名單無意向",
        "bf": "新增櫃詢客戶",
        "bg": "新增試聽學員",
        "bh": "新增正式學員",
        "bi": "操作",
        "bj": "不限",
        "bk1": "01.毛名單數",
        "bk": "02.意向客戶",
        "bl": "03.櫃詢客戶",
        "bm": "04.試聽客戶",
        "bn": "05.轉正客戶",
        "bp": "招生轉化率",
        "bq": "確認關閉？",
        "br": "請選擇跟進類型！",
        "bs": "每頁 ",
        "bt": " 條",
        "bu": "當前頁",
        "person": "人",
        "each": "個",
        "data": [
            "01.毛名單數",
            "02.招生有效名單",
            "02.意向客戶",
            "03.櫃詢客戶",
            "04.試聽客戶",
            "05.轉正客戶"
        ],
        "gmcRosterTitle": '集團名單提醒',
        "gmcRosterPlaceholder": '選擇名單狀態',
        "gmcRosterTab1": '全部',
        "gmcRosterTab2": '更新',
        "gmcRosterTab3": '櫃詢',
        "gmcRosterTab4": '試聽',
        "gmcRosterPopTitle": '我的集團名單提醒詳情',
        "gmcRosterTip": '本周及上周導入名單提醒',
        listTitle: '電轉率: 有效名單轉化為意向客戶數量(轉化率)',
        ca: "新增待跟蹤意向客戶",
        cb: "新增無意向客戶",
        cd: "新增邀約客戶",
        ce: "新增正式學員",
        cc: "暫無集團名單提醒",
        listTitle1: '名單有效率: 毛名單轉化為有效客戶數量(轉化率)',
        cf: '業績統計',
        cg: '請選擇班組',
    },
    Goalmanage: {
        "aa": "招生活動管理",
        "ab": "發布活動",
        "ac": "開始日期",
        "ad": "至",
        "ae": "結束日期",
        "af": "創建人：",
        "ag": "創建人選擇",
        "ah": "請輸入招生活動名稱",
        "ai": "查詢",
        "aj": "掃碼分享活動",
        "ak": "查看活動",
        "al": "編輯",
        "am": "刪除活動",
        "an": "確定刪除該活動？",
        "ao": "取消",
        "ap": "確定",
        "aq": "這裏是UE測試",
        "ar": "發布活動",
        "as": "編輯活動",
        "at": "預覽",
        "au": "刪除",
        "av": "復制活動",
        "aw": "長度在 2 到 10 個字符",
        "ax": "請選擇活動開始時間",
        "ay": "請選擇活動結束時間",
        "az": "不限",
        "ba": "確認關閉？",
        "bb": "每頁 ",
        "bc": " 條",
        "bd": "當前頁:",
        "be": "招生目標管理",
        "bf": "新增目標",
        "bg": "請輸入招生目標名稱",
        "bh": "查看目標",
        "bi": "目標基本信息",
        "bj": "基礎資料",
        "bk": "目標名稱：",
        "bl": "開始時間：",
        "bm": "結束時間：",
        "bn": "跟蹤人次：",
        "bo": "最少",
        "bp": "達標",
        "bq": "櫃詢/試聽人次：",
        "br": "學員轉正人次：",
        "bs": "自主招生跟蹤最大人次：",
        "bt": "參與目標的考核員工",
        "bu": "選擇職工：",
        "bv": "女",
        "bw": "男",
        "bsk": "目標完成狀況",
        "by": "目標完成率",
        "bz": "統計維度：",
        "ca": "參與目標的員工",
        "cb": "轉正人次",
        "cc": "刪除目標",
        "cd": "確定刪除該目標？",
        "ce": "操作",
        "cf": "查看",
        "cg": "刪除",
        "ch": "跟蹤人次完成率",
        "ci": "跟蹤人次未完成率",
        "cj": "櫃詢/試聽人次完成率",
        "ck": "櫃詢/試聽人次未完成率",
        "cl": "人",
        "cm": "轉正人次",
        "cn": "請填寫所有的必填內容！"
    },
    Crmactivemanage: {
        "aa": "招生活動管理",
        "ab": "發布活動",
        "ac": "活動時間段：",
        "ad": "開始日期",
        "ae": "至",
        "af": "結束日期",
        "ag": "創建人：",
        "ah": "創建人選擇",
        "ai": "活動類型：",
        "aj": "選擇招生活動類型",
        "ak": "不限",
        "al": "普通活動",
        "am": "招生券活動",
        "an": "招生渠道類型：",
        "ao": "選擇招生渠道類型",
        "ap": "招生渠道明細：",
        "aq": "選擇招生渠道明細",
        "ar": "請輸入招生活動名稱",
        "as": "查詢",
        "at": "網頁二維碼：",
        "au": "小程序二維碼：",
        "av": "掃碼分享活動",
        "aw": "網頁版鏈接：",
        "ax": "查看活動",
        "ay": "編輯",
        "az": "刪除活動",
        "ba": "確定刪除該活動？",
        "bb": "取消",
        "bc": "確定",
        "bd": "這裏是UE測試",
        "be": "發布活動",
        "bf": "編輯活動",
        "bg": "操作",
        "bh": "預覽",
        "bi": "刪除",
        "bj": "復制活動",
        "bk": "請輸入招生活動名稱",
        "bl": "長度在 2 到 10 個字符",
        "bm": "請選擇活動開始時間",
        "bn": "請選擇活動結束時間",
        "bo": "確認關閉？",
        "bp": "每頁 ",
        "bq": " 條",
        "br": "當前頁: ",
        "bs": "招生名單管理",
        "bt": "招生券名稱",
        "bu": "請選擇招生券名稱",
        "bv": "請輸入姓名/主要聯系電話/招生券編號",
        "bw": "招生券管理",
        "bss": "生成招生券",
        "by": "導出",
        "bz": "使用狀態",
        "ca": "請選擇狀態",
        "cb": "未使用",
        "cc": "已使用",
        "cd": "請輸入招生券名稱搜索",
        "ce": "招生券描述",
        "cf": "請輸入招生券名稱",
        "cg": "請輸入招生券描述，字數控制在50字以內 0/50",
        "ch": "有效時間",
        "ci": "招生券個數",
        "cj": "請輸入招生券個數",
        "ck": "請選擇開始日期",
        "cl": "請選擇結束日期",
        "cm": "報表內容為空，不可導出",
        "cn": "請輸入活動名稱",
        "co": "招生名單",
        "cp": "掃碼分享活動",
        // 海報管理
        title1: '發布海報活動',
        title2: '編輯海報活動',
        title3: '海報活動',
        pageTitle: '海報活動管理',
        placeholder1: '請輸入海報活動名稱',
        label_text1: '發布人：',
        placeholder2: '選擇發布人',
        btn_see: '預覽',
        btn_copy: '復制活動',
        btn_del: '刪除',
        dialog_title: '復制活動',
        dialog_cont: '確定復制該活動？'

    },
    Admissioncue: {
        "aa": "招生有效名單",
        "ab": "導入有效名單",
        "ac": "新增招生有效名單",
        "ad": "招生渠道類型：",
        "ae": "招生渠道類型",
        "af": "不限",
        "ag": "活動：",
        "ah": "請選擇活動名稱",
        "ai": "招生渠道明細：",
        "aj": "請選擇招生渠道明細",
        "ak": "名單類型：",
        "al": "請選擇名單類型",
        "am": "不限",
        "an": "未確認無意向名單",
        "ao": "請輸入中/英文名、手機號",
        "ap": "查詢",
        "aq": "請輸入家屬手機號",
        "ar": "批量分配",
        "as": "轉為我的意向客戶",
        "at": "批量無意向",
        "au": "提示",
        "av": "立即跟進",
        "aw": "暫不跟進",
        "ax": "確定",
        "ay": "綁定學員",
        "az": "綁定學員名稱：",
        "ba": "請輸入學員名稱後選擇",
        "bb": "綁定關系：",
        "bc": "請選擇綁定關系",
        "bd": "分配",
        "be": "主負責人：",
        "bf": "請選擇主負責人",
        "bg": "副負責人：",
        "bh": "請選擇副負責人",
        "bi": "目標學校：",
        "bj": "請選擇目標學校",
        "bk": "異動原因：",
        "bl": "請選擇異動原因",
        "bm": "備註：",
        "bn": "請輸入異動原因",
        "bo": "已顯示列",
        "bp": "未顯示的列",
        "bq": "確定刪除該名單？",
        "br": "待跟蹤",
        "bs": "持續跟蹤",
        "bt": "已櫃詢",
        "bu": "已試聽",
        "bv": "已轉正",
        "bw": "無意向",
        "bsw": "編輯招生有效名單",
        "by": "招生有效名單",
        "bz": "今日新增招生有效名單",
        "ca": "操作",
        "cb": "我要跟進",
        "cc": "轉校",
        "cd": "普通回訪",
        "ce": "櫃詢",
        "cf": "試聽",
        "cg": "轉正",
        "ch": "跟進無意向",
        "ci": "顯示 列切換",
        "cj": "列變化",
        "ck": "請填寫所有的必填內容！",
        "cl": "確認關閉？",
        "cm": "每頁 ",
        "cn": " 條",
        "co": "當前頁: ",
        "cp": "導入招生有效名單",
        "cq": "上傳文件",
        "cr": "預覽招生有效名單",
        "cs": "導入結果",
        "ct": "將文件拖到此處，或",
        "cu": "點擊上傳",
        "cv": "下載導入招生有效名單模板",
        "cw": "操作步驟",
        "csl": "1.首次使用導入功能或者沒有導入模版，請點擊上傳文件下方的鏈接下載對應的導入模板，請嚴格參照模板導入數據，否則可能無法導入數據",
        "cy": "2.上傳文件，導入數據",
        "cz": "上傳中（",
        "da": "正在上傳並解析數據，請稍等…",
        "db": "上一步",
        "dc": "下一步",
        "dd": "繼續上傳",
        "de": "完成",
        "df": "上傳文件",
        "dg": "預覽招生有效名單",
        "dh": "導入結果",
        "di": "本次導入成功數據",
        "dj": "本次導入失敗數據",
        "dk": "條",
        "dl": "失敗數據列表",
        "dm": "地區",
        "dn": "園所編號",
        "do": "姓名",
        "dp": "主要聯系手機",
        "dq": "所在地址",
        "dr": "電銷姓名",
        "ds": "備註",
        "dt": "招生有效名單名稱",
        "du": "招生有效名單ID",
        "dv": "失敗原因",
        "dw": "名單檢索",
        "dss": "請輸入完整的手機號、姓名，多個手機號或者姓名以|符號分割查詢",
        "dy": "編輯列",
        "dz": "取消轉正後，將會刪除轉正業績，需要重新轉正！",
        "ea": "上傳頭像圖片只能是 JPG 格式!",
        "eb": "上傳頭像圖片大小不能超過 2MB!",
        cac: '不限',
        tips1: '您有',
        tips2: '條名單更新信息未讀提醒，請及時查看更新信息',
        cad: '新消息：',
        cae: '請選擇是否新消息',
        caf: '是',
        cag: '否',
        plzwmmd: '批量轉為毛名單'
    },
    Customersmanage: {
        "aa": "意向客戶管理",
        "ab": "新增意向客戶",
        "ac": "客戶意向星级：",
        "ad": "客戶狀態：",
        "ae": "請選擇客戶狀態",
        "af": "活動：",
        "ag": "請選擇活動名稱",
        "ah": "主負責人：",
        "ai": "選擇主負責人",
        "aj": "不限",
        "ak": "協助負責人：",
        "al": "選擇協助負責人",
        "am": "請輸入中/英文名、手機號、主要聯系手機",
        "an": "查詢",
        "ao": "轉回招生有效名單",
        "ap": "批量無意向",
        "aq": "綁定學員",
        "ar": "綁定學員名稱：",
        "as": "請輸入學員名稱後選擇",
        "at": "綁定關系：",
        "au": "請選擇綁定關系",
        "av": "確定",
        "aw": "編輯列",
        "ax": "已顯示列",
        "ay": "未顯示的列",
        "az": "提示",
        "ba": "轉正學員",
        "bb": "學員編號：",
        "bc": "請輸入學員編號",
        "bd": "課程別：",
        "be": "請選擇首次報名課程別",
        "bf": "轉正日期：",
        "bg": "請選擇轉正日期",
        "bh": "備註：",
        "bi": "備註信息，字數控制在50字左右",
        "bj": "取 消",
        "bk": "取消",
        "bl": "確定刪除該名單？",
        "bm": "我的意向客戶",
        "bn": "此客戶不屬於您的意向客戶，不可以跟進",
        "bo": "請輸入學員編號",
        "bp": "請選擇課程別",
        "bq": "請選擇轉正日期",

        "br": "不限",
        "bs": "待跟蹤",
        "bt": "持續跟蹤",
        "bu": "已櫃詢",
        "bv": "已試聽",
        "bvN1": "待櫃詢",
        "bvN2": "待試聽",
        "bvN3": "未櫃詢",
        "bvN4": "未試聽",
        "bvN5": "無意向待審核",
        "bvN6": "無意向",
        "bvN7": "無效名單",
        "bvN8": "已轉正",

        "bw": "編輯意向客戶",
        "bss": "操作",
        "by": "跟進",
        "bz": "轉正",
        "ca": "列變化",
        "cb": "確認關閉？",
        "cc": "此客戶已轉正，不可以跟進！",
        "cd": "此客戶不屬於您的意向客戶，不可以跟進",
        "ce": "請選擇跟進類型！",
        "cf": "顯示 列切換",
        "cg": "請填寫所有的必填內容！",
        "ch": "每頁 ",
        "ci": " 條",
        "cj": "當前頁: ",
        "ck": "上傳頭像圖片只能是 JPG 格式!",
        "cl": "上傳頭像圖片大小不能超過 2MB!",
        caa: '渠道：',
        cab: '請選擇渠道',
        cac: '不限',
        tabs1: '我的意向客戶',
        tabs2: 'TMK協助跟蹤',
        tips1: '您有',
        tips2: '條名單更新信息未讀提醒，請及時查看更新信息',
        cad: '新消息：',
        cae: '請選擇是否新消息',
        caf: '是',
        cag: '否',
        cba: '創建時間',
        cbb: '最後跟蹤時間',
        cbc: '請選擇是否櫃詢',
        cbd: '請選擇是否試聽',
        cbe: '請選擇活動',
        cbf: '請選擇負責人',
        cbg: '請選擇渠道類型',
        cbh: '請選擇渠道明細',
        cbi: '請選擇是否有新提醒',
        cbj: '請選擇接通狀態',
        cbk: '跟進次數小於等於',
        cbl: '是否七日內未跟蹤名單',
        cbm: '可搜尋中英文名、手機、標籤、意向課程、接觸點',
        cbn: '申請變更渠道',
        daa: '試聽邀約課表',
        dab: '請選擇班組',
        dac: '請選擇班種',
        dad: '可搜尋班級名稱',
        dae: '普通公開課',
        daf: '試讀公開課',
        dba: '更改渠道紀錄',
        dbb: '申請時間',
        dbc: '請選擇審核狀態',
        dbd: '請選擇目標渠道類型',
        dbe: '可搜尋中英文名、手機',
        dbf: '處於渠道保護期',
        dbg: '關閉',
        dbh: '請選擇目標渠道明細',
        dbj: '渠道變更紀錄',
        dbk: '申請變更',
        dbl: '變更為',
        dbm: '申請人',
        dbn: '申請變更時間',
        dbo: '備註',
        dbp: '附件',
        dbr: '圖片',
        eaa: '申請變更渠道',
        eab: '確定',
        eac: '該名單來源處於渠道保護期，不可隨意更改，申請後審核通過機率不是很大歐~請知曉',
        ead: '原渠道類型：',
        eae: '原渠道明细：',
        eaf: '更新渠道類型：',
        eag: '請選擇更新渠道類型',
        eah: '更新渠道明細：',
        eaj: '请請選擇更新渠道明細',
        eak: '變更時間：',
        eal: '請選擇變更時間',
        eam: '上傳附件：',
        ean: '請上傳圖片',
        eao: '更改原因：',
        eap: '請輸入更改原因',
    },
    Invitationauditionmanage: {
        "aa": "試聽管理",
        "ab": "試聽班級：",
        "ac": "不限",
        "ad": "試聽日期：",
        "ae": "開始日期",
        "af": "至",
        "ag": "結束日期",
        "ah": "主負責人：",
        "ai": "選擇主負責人",
        "aj": "試聽類型：",
        "ak": "請選擇試聽類型",
        "al": "不限",
        "am": "公開課試聽",
        "an": "插班試聽",
        "ao": "請輸入中/英文名、手機號",
        "ap": "查詢",
        "aq": "學員已試聽成功！",
        "da": "學員已成功到訪！",
        "ar": "繼續跟進",
        "as": "暫不跟進",
        "at": "選擇原因：",
        "au": "請選擇原因",
        "av": "請輸入其它原因",
        "aw": "綁定學員",
        "ax": "綁定學員名稱：",
        "ay": "請輸入學員名稱後選擇",
        "az": "綁定關系：",
        "ba": "請選擇綁定關系",
        "bb": "確定",
        "bc": "編輯列",
        "bd": "已顯示列",
        "be": "未顯示的列",
        "bf": "我的試聽管理",
        "bg": "新增試聽學員",
        "bh": "全部試聽",
        "bi": "取消試聽",
        "bj": "試聽成功",
        "bia": "未試聽",
        "bja": "已試聽",
        "bk": "操作",
        "bl": "列變化",
        "bm": "顯示 列切換",
        "bn": "確認關閉？",
        "bo": "每頁 ",
        "bp": " 條",
        "bq": "當前頁: ",
        "br": "櫃詢管理",
        "bs": "到訪日：",
        "bt": "時間：",
        "bu": "我的櫃詢管理",
        "bv": "全部",
        "bw": "未到訪",
        "db": "未到訪原因",
        "bss": "已到訪過",
        "by": "今日",
        "bz": "昨日",
        "ca": "本周",
        "cb": "本月",
        "cc": "已到訪",
        "cd": "未到訪",
        "ce": "確認關閉？",
        "cf": "每頁 ",
        "cg": " 條",
        "ch": "當前頁: ",
        ea: "已到訪",
        eh: "未到訪",
        eb: "到訪日",
        ec: "請選擇主負責人",
        ed: "櫃詢日期",
        ee: "請選擇櫃詢班組",
        ef: "請選學生類型",
        eg: "請輸入中/英文名、手機、意向課程",
    },
    Registeredlist: {
        "aa": "已報名名單",
        "ab": "主負責人：",
        "ac": "選擇主負責人",
        "ad": "協助負責人：",
        "ae": "選擇協助負責人",
        "af": "報名課程：",
        "ag": "請選擇報名課程",
        "ah": "不限",
        "ai": "報名日期：",
        "aj": "報名日期",
        "ak": "招生渠道類型：",
        "al": "招生渠道類型",
        "am": "招生渠道明細：",
        "an": "請選擇招生渠道明細",
        "ao": "可搜尋中英文名、手機、編號、接觸點、特殊学号",
        "ap": "查詢",
        "aq": "編輯列",
        "ar": "已顯示列",
        "as": "未顯示的列",
        "at": "確定",
        "au": "提示",
        "av": "取消轉正後，將會刪除轉正業績，需要重新轉正！",
        "aw": "取消",
        "ax": "我的已轉正名單",
        "ay": "待審核",
        "az": "無意向",
        "ba": "操作",
        "bb": "取消轉正",
        "bc": "列變化",
        "bd": "顯示 列切換",
        "be": "確認關閉？",
        "bf": "每頁 ",
        "bg": " 條",
        "bh": "當前頁: ",
        "bi": "上傳頭像圖片只能是 JPG 格式!",
        "bj": "上傳頭像圖片大小不能超過 2MB!",
        source_label: '招生來源類型',
        sourceList: ['外部招生', '內部招生', '專案招生'],
        dda: '已登記學籍名單',
        ddb: '申請渠道變更',
    },
    Losscustomermanage: {
        "aa": "無效客戶管理",
        "ab": "招生渠道類型：",
        "ac": "請選擇招生渠道類型",
        "ad": "請輸入中/英文名、手機號",
        "ae": "查詢",
        "af": "轉為招生有效名單",
        "ag": "是否確定此客戶已無意向，無法再次跟進？",
        "ah": "取消",
        "ai": "確定",
        "aj": "我的無效客戶",
        "ak": "待審核",
        "al": "無意向",
        "am": "操作",
        "an": "不限",
        "ao": "確認關閉？",
        "ap": "每頁 ",
        "aq": " 條",
        "ar": "當前頁: ",
        "as": "無意向客戶管理",
        "at": "我要跟蹤",
        "au": "審核",
        "av": "我的無意向客戶",
        ba: '創建時間',
        bb: '歷史最高意向級別',
        bc: '請選擇是否參與試聽',
        bd: '可搜尋意向課程、標籤',
        be: '轉毛名單',
        bf: '轉校',
        bg: '已選擇',
        bh: '目標學校',
        bj: '請選擇目標學校',
        bk: '異動原因',
        bl: '請輸入異動原因',
        ca: '批量轉毛名單',
        cb: '確認轉毛名單?',
    },
    overageListManage: {
        "title": "超齡名單",
        "s-title1": "設置超齡",
        "s-title2": "名單列表",
        "set-text1": "超齡日期 : ",
        "set-text2": "未設置",
        "set-text3": "立即設置",
        "set-text4": "備註 :",
        "set-text5": "超齡日期編輯後，立即生效，不影響已獲取的超齡名單數據",
        "empty": "暫無名單，請先設置超齡日期",
        "ab": "招生渠道類型：",
        "ac": "請選擇招生渠道類型",
        "ad": "請輸入中/英文名、手機號",
        "ae": "創建日期：",
        "af": "開始日期",
        "ag": "至",
        "ah": "結束日期",
        "ai": "查詢",
        "aj": "請選擇出生日期",
        "ak": "保存",
        'a1': '批量轉校',
        'a2': "已選擇",
        'a3': '轉校',
        'a4': '目標學校',
        'a5': '選擇目標學校',
        'a6': '異動原因',
        'a7': '請填寫異動原因'
    },
    Analysisreport: {
        "aa": "招生渠道業績統計表",
        "ab": "渠道咨詢報表",
        "ac": "招生月度咨詢統計表",
        "ad": "個人招生業績統計表",
        "ae": "招生月度業績統計表",
        "af": "校招生咨詢報表",
        ba: "招生分析類報表",
        bb: "選擇名單創建日期",
        bc: "市場分析類報表",
        bd: "請選擇招生渠道類型",
        be: "請選擇招生渠道明細",
        bf: "請選擇客戶狀態",
        bg: "請選擇主負責人",
        bh: "請選擇副負責人",
        ca: "跟蹤分析類報表",
        cb: "溝通時間",
        cc: "請輸入班組(課程科目)關鍵詞搜尋",
        cd: "請選擇是否邀約",
        ce: "請選擇是否到訪",
        cf: "跟進次數小於等於",
        cg: "請輸入跟進次數",
        ch: "請選擇溝通類型",
        ci: "請輸入學員中/英文名、主要聯繫電話",
        da: "活動分析類報表",
        db: "請輸入招生活動名稱、錄入人姓名",
        fa: "管控分析類報表",
        fb: "請選擇報名類型",
        fc: "可搜尋學生編號、學生姓名、負責人姓名",
        fd: "請選擇報名類型",
        fe: "可搜尋學生編號、學生姓名、負責人姓名",
    },
    Clientmanage: {
        "aa": "客戶管理",
        "ab": "請輸入中/英文名、手機號",
        "ac": "查詢",
        "ad": "編輯列",
        "ae": "已顯示列",
        "af": "未顯示的列",
        "ag": "確定",
        "ah": "選擇學校",
        "ai": "請輸入學校中/英文名、學校編號",
        "aj": "查詢",
        "ak": "暫無數據",
        "al": "取消",
        "am": "確定",
        "an": "操作",
        "ao": "分配",
        "ap": "學校名稱",
        "aq": "學校編號",
        "ar": "學校地址",
        "as": "時間安排",
        "at": "不限",
        "au": "請選擇學校",
        "av": "列變化",
        "aw": "顯示 列切換",
        "ax": "確認關閉？",
        "ay": "每頁 ",
        "az": " 條",
        "ba": "當前頁: ",
        "bb": "上傳頭像圖片只能是 JPG 格式!",
        "bc": "上傳頭像圖片大小不能超過 2MB!"
    },
    ListAllocationManagement: {
        aa: "待篩選毛名單",
        ab: "導入",
        ac: "創建時間",
        ad: "請選擇渠道類型",
        ae: "請選擇渠道明細",
        af: "請選擇活動",
        ag: "可搜尋姓名、主要聯繫人、主要聯繫手機、標名稱、意向課程信息、接觸點",
        ah: "批量分配篩選人",
        ai: "批量轉有效名單",
        aj: "您已選擇以下",
        ak: "則名單",
        al: "篩選人",
        am: "請選擇篩選人",
        an: "是否確認轉為有效名單?",
        ao: "導入毛名單",
        ap: "預覽毛名單",
        aq: "下載導入毛名單模板",
        ar: "待分配有效名單",
        as: "新增有效名單",
        ba: "招生人員管理",
        bb: "負責人姓名搜尋",
        bc: "名單交接",
        bd: "名單分配",
        be: "請選擇校外招交接人",
        bf: "請選擇校內招交接人",
        bg: "確認",
        mdfp: '名單分配'
    },
    Permission: {
        "aa": "您即將跳轉到招生CRM頁面",
        "ab": "秒後自動跳轉",
        "ac": "立刻前往",
        "ad": "用戶token失效",
        "ae": "您沒有CRM權限",
        "af": "您當前沒有CRM權限，請聯系相關人員開通權限"
    },
    websiteBuilding: {
        "aa": "功能正在建設中"
    },
    havePermission: {
        a1: '您即將跳轉到招生CRM頁面',
        a2: '秒後自動跳轉',
        a3: '立刻前往',
    },
    noPermission: {
        a1: '您當前沒有CRM權限，請聯系相關人員開通權限'
    }


}